import { Event, EventStatus } from "@/types";
import { formatDate, formatEventType } from "@/utils";
import { Check, Close } from "@mui/icons-material";
import { FC } from "react";
import {
  Datagrid,
  FunctionField,
  List,
  Pagination,
  TextField,
} from "react-admin";
import { TopToolbar } from "../top-toolbar";

const EventsList: FC = () => {
  return (
    <List<Event>
      perPage={30}
      actions={<TopToolbar />}
      pagination={<Pagination rowsPerPageOptions={[10, 15, 30, 50]} />}
      sort={{ field: "createdAt", order: "DESC" }}
      empty={<></>} // needn't empty list component
    >
      <Datagrid
        bulkActionButtons={false}
        style={{ tableLayout: "fixed" }}
        rowClick={"show"}
      >
        <TextField<Event>
          noWrap
          label="Title"
          source="title"
          style={{ display: "block" }}
          sortable={false}
        />
        <FunctionField<Event>
          label="Type"
          source="type"
          render={({ type }) => formatEventType(type)}
        />
        <TextField<Event>
          noWrap
          label="Participants"
          source="participantsCount"
          style={{ display: "block" }}
          sortable={true}
        />
        <FunctionField<Event>
          label="Cancelled"
          source=""
          render={({ status }) =>
            status === EventStatus.ACTIVE ? <Close /> : <Check />
          }
          sortable={false}
          maxWidth={1}
        />
        <FunctionField<Event>
          label="Expired"
          source=""
          render={({ isExpired }) => (isExpired ? <Check /> : <Close />)}
          sortable={false}
        />
        <FunctionField<Event>
          label="Created"
          source="createdAt"
          render={({ createdAt }) => formatDate(createdAt)}
        />
      </Datagrid>
    </List>
  );
};

export { EventsList };
